module.exports = __webpack_public_path__ + "img/pass.95bf479e.png";